import { z } from 'zod';

export const callParamsSchema = z.object({
  userId: z.string(),
  interviewId: z.string(),
  simulationScriptId: z.string().optional(),
});

export type CallParams = z.infer<typeof callParamsSchema>;
